<template>
  <div :class="$style.container">
    <span
      v-for="({ id, name }, index) in userGroupList"
      :key="id"
    >
      <a
        :class="$style.link"
        :href="href({ id })"
        target="_self"
        @click="closeModal"
      >{{ name }}</a>{{ getSeparator(index) }}
    </span>
  </div>
</template>

<script>
import { ItemTypeConsts, getDetailsRoute } from 'client/util/Constants';
import { get } from 'lodash';
import ModalEventBus from 'components/Modal/ModalEventBus';

export default {
  name: 'UserGroupListWithLink',

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    userGroupList() {
      return get(this.item, 'userGroupList', []);
    },
  },

  methods: {
    closeModal() {
      ModalEventBus.close();
    },

    getSeparator(index) {
      if (index + 1 === this.userGroupList.length) {
        return '';
      }
      return ', ';
    },

    href(item) {
      return getDetailsRoute(ItemTypeConsts.userGroup, item);
    },
  },
};
</script>

<style scoped module>
@value (jcGrey800) from '~css/brand-colors.css';

.link,
.link.link:hover {
  color: jcGrey800;
  text-decoration: underline;
}
</style>
